export const whiteListedDomains = /com|net|com.mx/;
